function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint react:true, es6:true, node:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['react', 'classnames', 'pub_config', '/util/etask.js', 'hola_opt', '/www/hola/pub/install_util.js', '/www/hola/pub/install_links.js', '/www/hola/pub/util.js', '/www/hola/pub/site_load.js', '/www/hola/pub/react_util.js', '/util/url.js', '/www/hola/pub/experiment_util'], (React, cn, config, etask, hopt, iutil, ilinks, www_util, site_load, react_util, zurl, experiment_util) => {
  var E = {};
  var url2md5 = config.url2md5;
  var useState = React.useState,
    useEffect = React.useEffect,
    useContext = React.useContext,
    useRef = React.useRef,
    Fragment = React.Fragment;
  var T = props => typeof props == 'string' ? props : props.children;
  experiment_util = experiment_util.default;
  var Install_context = React.createContext();
  var Step_unsupported_ext = () => {
    useEffect(() => {
      location.href = '/join_network?mac_beta=1';
    }, []);
    return null;
  };
  var Start_button = props => {
    var start = () => {
      etask(function* () {
        var ctx = yield iutil.init_ctx(props);
        E.install_flow(document.body, ctx);
      });
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "main-download",
      "data-testid": "start_button"
    }, /*#__PURE__*/React.createElement("a", {
      className: "link",
      onClick: start
    }, /*#__PURE__*/React.createElement("span", {
      className: "start"
    }, /*#__PURE__*/React.createElement(T, null, "Start"))));
  };
  var Start_button_new = props => {
    var start = () => {
      etask(function* () {
        var ctx = yield iutil.init_ctx(props);
        E.install_flow(document.body, ctx);
      });
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "main-download",
      "data-testid": "start_button",
      onClick: start
    }, props.children);
  };
  var check_redirect = (ctx, opt) => {
    var redir = hopt.www_hola.main_install_flow || 'join2';
    var ref = `install_${redir}${ctx.src ? '_' + ctx.src : ''}`;
    var need_choose_plan = !(opt.skip && opt.skip.choose_plan) && iutil.need_choose_plan(ctx) && !ctx.env.is_safari;
    if (need_choose_plan) {
      var url = `/${redir}?ref=${ref}`;
      if (opt.redirect_cb) opt.redirect_cb(url);else location.href = url;
      return true;
    }
  };
  var install_flow = (root, ctx, opt = {}) => {
    if (!root) return;
    if (opt.flow == 'browser') {
      if (!ctx.env.is_ff) return void iutil.complete(ctx, opt);
      opt.skip = {
        choose_plan: true,
        exe: true
      };
    }
    E.agree = opt.agree;
    E.uninstall_flow = opt.uninstall_flow;
    return void new_install_flow(ctx, opt);
  };
  var Install_agree = props => {
    var next = props.next;
    var on_next = () => {
      E.agree = true;
      if (location.pathname == '/join2') www_util.perr({
        id: 'www_join2_agree'
      });
      next(true);
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "install_agree"
    }, /*#__PURE__*/React.createElement("p", null, "Your use of Hola is free, because Hola shares the resources of its users to benefit all and for business use by ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://bright-sdk.com/eula"
    }, "Bright Data")), /*#__PURE__*/React.createElement("p", null, "By installing the application, you agree you have read and accepted the ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://hola.org/legal/sla"
    }, "Hola End User Agreement"), " and the ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://hola.org/legal/privacy"
    }, "Hola Privacy Statement")), /*#__PURE__*/React.createElement("p", null, "Hola FREE does not secure your traffic. If you need privacy and security ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      href: "https://hola.org/premium?ref=install_flow_1b_security",
      rel: "noopener noreferrer"
    }, "subscribe to PLUS")), /*#__PURE__*/React.createElement("button", {
      className: "hola_btn",
      onClick: on_next
    }, /*#__PURE__*/React.createElement("span", null, "I Agree")));
  };
  var Install_exe = props => {
    var ctx = useContext(Install_context);
    var is_mac = ctx.env.is_mac;
    var next = props.next;
    var filename = ilinks.get_filename({
      agree: E.agree,
      uninstall_flow: E.uninstall_flow
    });
    var download_click = () => etask(function* () {
      yield iutil.download_exe(ctx, _objectSpread(_objectSpread({}, props), {}, {
        name: 'exe',
        agree: E.agree,
        uninstall_flow: E.uninstall_flow
      }));
      next();
    });
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      substep = _useState2[0],
      set_substep = _useState2[1];
    useEffect(() => {
      download_click();
      var timeout = is_mac ? 10000 : 5000;
      var timer = setTimeout(() => set_substep(true), timeout);
      return () => clearTimeout(timer);
    }, []);
    var cls = cn('install_exe', {
      mac: is_mac
    });
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("p", null, "When download completes:"), !(is_mac && substep) && /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, "Run"), " ", filename, " to install Hola"), /*#__PURE__*/React.createElement("div", {
      className: "install_exe-images"
    }, /*#__PURE__*/React.createElement("img", {
      className: cn('arrow', 'lazyload'),
      alt: "arrow",
      src: url2md5('/www/hola/pub/img/install_flow/' + 'download_arrow.svg')
    }), /*#__PURE__*/React.createElement("img", {
      className: cn('file', 'lazyload'),
      alt: "file",
      src: url2md5('/www/hola/pub/img/install_flow/' + 'download_file.svg')
    }), !is_mac && substep && /*#__PURE__*/React.createElement("img", {
      className: cn('confirm', 'lazyload'),
      alt: "confirm",
      src: url2md5('/www/hola/pub/img/install_flow/' + 'confirm.svg')
    })), /*#__PURE__*/React.createElement("p", {
      className: "install_exe-click"
    }, /*#__PURE__*/React.createElement("a", {
      onClick: download_click
    }, "Click here"), " if your download doesn't start")), is_mac && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, "Drag"), " it to \"Applications\""), /*#__PURE__*/React.createElement("div", {
      className: "install_exe-images"
    }, /*#__PURE__*/React.createElement("img", {
      className: cn('drag', 'lazyload'),
      alt: "drag",
      src: url2md5('/www/hola/pub/img/install_flow/' + 'exe_mac_drag.svg')
    })))), is_mac && substep && /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, "Open"), " \"Hola\" from \"Applications\" to run Hola"), /*#__PURE__*/React.createElement("div", {
      className: "install_exe-images mac_app"
    }, /*#__PURE__*/React.createElement("div", {
      className: "applications"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "applications",
      className: 'lazyload',
      src: url2md5('/www/hola/pub/img/install_flow/exe_mac_apps.svg')
    }), /*#__PURE__*/React.createElement("span", null, "Applications")), /*#__PURE__*/React.createElement("img", {
      className: cn('arrow_right', 'lazyload'),
      alt: "arrow_right",
      src: url2md5('/www/hola/pub/img/ic_arrow.svg')
    }), /*#__PURE__*/React.createElement("div", {
      className: "hola"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "hola",
      className: 'lazyload',
      src: url2md5('/www/hola/pub/img/hola_flame.svg')
    }), /*#__PURE__*/React.createElement("span", null, "Hola")))), /*#__PURE__*/React.createElement("li", {
      style: {
        maxWidth: 'none'
      }
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, "Click"), " \"Open\", when the new tab opens"), /*#__PURE__*/React.createElement("div", {
      className: "install_exe-images"
    }, /*#__PURE__*/React.createElement("img", {
      className: cn('open_app', 'lazyload'),
      alt: "open_app",
      src: url2md5('/www/hola/pub/img/install_flow/' + 'exe_mac_open.svg')
    })))));
  };
  var Install_ext = () => {
    var ctx = useContext(Install_context);
    var _ctx$env = ctx.env,
      is_chrome = _ctx$env.is_chrome,
      is_opera = _ctx$env.is_opera,
      is_chromium_edge = _ctx$env.is_chromium_edge,
      is_ff = _ctx$env.is_ff;
    var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      empty = _useState4[0],
      set_empty = _useState4[1];
    var on_next = () => {
      if (is_chrome || is_opera || is_chromium_edge) {
        var install_opt = {
          perr_on_step: 'ext_redirect',
          name: 'ext'
        };
        iutil.install_perr('ext_redirect_to_store', ctx, install_opt);
        iutil.track_download({
          name: 'ext',
          install_opt: install_opt
        });
        location.href = site_load.GDL[is_opera ? 'opera' : is_chromium_edge ? 'edge' : 'chrome'].url;
        return;
      }
      set_empty(true);
      etask(function* () {
        www_util.perr({
          id: 'www_vpn_install_step_ext_4'
        });
        yield iutil.download_ext(ctx);
        www_util.perr({
          id: 'www_vpn_install_step_ext_5'
        });
        iutil.install_perr('ext_download_success', ctx, {
          name: 'ext_instruct'
        });
        iutil.complete(ctx);
      });
    };
    return !empty && /*#__PURE__*/React.createElement("div", {
      className: "install_ext"
    }, /*#__PURE__*/React.createElement("h3", null, "Install Hola ", is_ff ? 'Add-on' : 'Extension'), /*#__PURE__*/React.createElement("div", {
      className: "install_ext-images"
    }, /*#__PURE__*/React.createElement("img", {
      src: url2md5('/www/hola/pub/img/install_flow/ext1.png'),
      alt: "ext1",
      className: cn('ext1', 'lazyload')
    }), /*#__PURE__*/React.createElement("img", {
      src: url2md5('/www/hola/pub/img/install_flow/ext2.png'),
      alt: "ext2",
      className: cn('ext2', 'lazyload')
    }), /*#__PURE__*/React.createElement("img", {
      src: url2md5('/www/hola/pub/img/install_flow/ext3.png'),
      alt: "ext3",
      className: cn('ext3', 'lazyload')
    }), /*#__PURE__*/React.createElement("img", {
      src: url2md5('/www/hola/pub/img/plus/pricing_badge_app.svg'),
      alt: "ext_badge",
      className: cn('ext_badge', 'lazyload')
    })), /*#__PURE__*/React.createElement("p", null, "Click \"Next\" to install the Hola ", is_ff ? 'Firefox' : is_opera ? 'Opera' : is_chromium_edge ? 'Edge' : 'Chrome', " ", is_ff ? 'Add-on' : 'extension', " to unblock any website"), /*#__PURE__*/React.createElement("button", {
      className: "hola_btn",
      onClick: on_next
    }, /*#__PURE__*/React.createElement("span", null, "Next")));
  };
  var Install_hola = props => {
    var ctx = useContext(Install_context);
    var on_close = props.on_close,
      unsupported = props.unsupported;
    if (unsupported) {
      return /*#__PURE__*/React.createElement("div", {
        className: "container install_unsupported"
      }, /*#__PURE__*/React.createElement(Step_unsupported_ext, null));
    }
    var _useState5 = useState(props.steps),
      _useState6 = _slicedToArray(_useState5, 2),
      steps = _useState6[0],
      set_steps = _useState6[1];
    var first = steps.findIndex(({
      done
    }) => !done);
    if (first == -1) first = 0;
    var _useState7 = useState(first),
      _useState8 = _slicedToArray(_useState7, 2),
      current = _useState8[0],
      set_current = _useState8[1];
    var sent_perrs = useRef({});
    var set_step = num => {
      if (!steps[num]) return;
      if (steps[num].done) return void set_step(num + 1);
      if (!sent_perrs.current[num]) {
        sent_perrs.current[num] = true;
        iutil.install_perr(`${steps[num].name}_next_step`, ctx);
      }
      set_current(num);
    };
    var step = steps[current];
    var next = disabled => {
      set_steps(steps.map((s, i) => i == current ? _objectSpread(_objectSpread({}, s), {}, {
        done: true,
        disabled: !!disabled
      }) : s));
      set_step(current + 1);
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "container install_hola"
    }, /*#__PURE__*/React.createElement("div", {
      className: "install_hola-desc"
    }, /*#__PURE__*/React.createElement("ul", {
      className: "install_hola-list"
    }, steps.map((s, i) => {
      var cls = cn('install_hola-button', {
        done: s.done,
        disabled: s.disabled,
        active: i == current
      });
      return /*#__PURE__*/React.createElement("li", {
        key: s.name,
        className: cls
      }, /*#__PURE__*/React.createElement("span", null, s.done ? '' : i + 1), /*#__PURE__*/React.createElement("button", {
        disabled: s.disabled,
        onClick: () => set_step(i)
      }, s.name == 'agree' && /*#__PURE__*/React.createElement(Fragment, null, "Terms and Conditions &", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "download"), " Hola."), s.name == 'exe' && 'Install Hola', s.name == 'ext' && 'Install Hola Extension'));
    })), /*#__PURE__*/React.createElement("div", {
      className: "install_hola-content"
    }, step.name == 'agree' && /*#__PURE__*/React.createElement(Install_agree, {
      next: next
    }), step.name == 'exe' && /*#__PURE__*/React.createElement(Install_exe, _extends({}, props, {
      next: next
    })), step.name == 'ext' && /*#__PURE__*/React.createElement(Install_ext, null))), /*#__PURE__*/React.createElement("a", {
      href: "/",
      onClick: on_close
    }, /*#__PURE__*/React.createElement("img", {
      className: cn('install_hola-logo', 'lazyload'),
      alt: "logo",
      src: url2md5('/www/hola/pub/img/logo.svg')
    })), /*#__PURE__*/React.createElement("button", {
      className: "install_hola-close",
      onClick: on_close
    }));
  };
  var new_install_flow = (ctx, opt) => {
    if (ctx.force_store_redirect) return void iutil.complete(ctx, {
      redirect_to_store: 1
    });
    if (check_redirect(ctx, opt)) return;
    opt.need_agree = !opt.agree && !(ctx.env.is_mobile || ctx.env.is_nix) && iutil.t.need_exe(ctx);
    var steps = ['agree', 'exe', 'ext'].map(s => {
      var need = iutil.need_step(s, ctx, opt);
      return {
        name: s,
        done: !need,
        disabled: !need
      };
    });
    var unsupported = ctx.env.is_mac && ctx.env.is_safari;
    var todo = steps.filter(({
      done
    }) => !done);
    if (!unsupported && !todo.length) return void iutil.complete(ctx);
    iutil.install_perr('start_install', ctx, {
      name: todo[0] && todo[0].name || 'unsupported_ext'
    });
    var root = document.createElement('div');
    root.className = 'install_hola-wrapper';
    document.body.appendChild(root);
    document.body.style.position = 'fixed';
    var on_close = () => {
      document.body.style.position = 'relative';
      document.body.removeChild(root);
    };
    react_util.dom_render(/*#__PURE__*/React.createElement(Install_context.Provider, {
      value: ctx
    }, /*#__PURE__*/React.createElement(Install_hola, _extends({}, opt, {
      on_close: on_close,
      steps: steps,
      unsupported: unsupported
    }))), root);
  };
  E = {
    install_flow,
    Start_button,
    Start_button_new,
    t: {
      Install_context
    }
  };
  return E;
});